module.exports = __webpack_public_path__ + "img/hero-center-graphic.bc4c91a4.svg";